import React, { useEffect } from 'react';
import ApplicationLayout from '../../../components/layouts/ApplicationLayout';
import {
  // getWinLostOverallOfPlatform,
  getWinLossOverallPlatform,
  getWinLostByProvider,
  getWinLossGroupUserByPlatform,
} from '../../../api/cms/summary';
import { LoadingBox } from '../../../components/LoadingBox';
import useSWR from 'swr';
import { Paper, Typography, Box, Grid } from '@material-ui/core';
import { toast } from 'react-toastify';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Link, useParams, useLocation, useHistory } from 'react-router-dom';
import Breadcrumbs from '../../../components/Breadcrumbs';
import { modifyArray } from '../../../utils/array';
import { genParamsQueryFromDateRange, useDateRange } from '../../../utils/datetime';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import Thead from '../../../components/table/Thead';
import TablePaginationActions from '../../../components/table/TablePaginationActions';
import RoyaltyFeeGroup from '../../../components/summary/RoyaltyFeeGroup';
import {
  groupUserTableHead as tableHead,
  headGroupTable,
  overAllTableHead,
  overAllHeadGroupTable,
  headPlaformGroupTable,
} from '../../../components/summary/thead-data';
import queryString from 'query-string';
import SummaryDateRangeContent from '../../../components/summary/SummaryDateRangeContent';

const PlatformGroupUser = () => {
  let { platformId, providerId } = useParams();
  let location = useLocation();
  const { search } = useLocation();
  const history = useHistory();
  let preventUrl = location.pathname
    .split('/')
    .filter((x) => x)
    .slice(0, 3)
    .join('/');

  const paramsString = queryString.parse(search);

  const [dateRange, setDateRange] = useDateRange(paramsString);

  const searchParam = React.useMemo(() => {
    return genParamsQueryFromDateRange(dateRange);
  }, [dateRange]);

  useEffect(() => {
    console.log('prevent: ', preventUrl);
    console.log('search param: ', searchParam);
    return () => {};
  }, []);

  const onChangeDateRange = (range) => {
    setDateRange(range);
    const newSearchUrl = genParamsQueryFromDateRange(range);
    history.replace({
      pathname: '',
      search: `?${newSearchUrl}`,
      state: { isActive: true },
    });
  };

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const { data, error } = useSWR(
    ['overAll', platformId, dateRange],
    () =>
      getWinLossOverallPlatform({
        platform_code: platformId,
        provider_code: providerId,
        from_time: dateRange.startDateValue,
        to_time: dateRange.endDateValue,
      }),
    { revalidateOnFocus: false },
  );

  const { data: dataDetail, error: errorDetail } = useSWR(
    ['getProviderByPlatform', page, rowsPerPage, platformId, dateRange],
    (url, page, limit, platformId) =>
      getWinLostByProvider({
        page: page + 1,
        limit,
        platform_code: platformId,
        from_time: dateRange.startDateValue,
        to_time: dateRange.endDateValue,
      }),
  );

  const { data: dataReport, error: errorReport } = useSWR(
    ['getWinLossGroupUserByPlatform', page, rowsPerPage, platformId, providerId, dateRange],
    (url, page, limit, platformId) =>
      getWinLossGroupUserByPlatform({
        page: page + 1,
        limit,
        platform_code: platformId,
        provider_code: providerId,
        from_time: dateRange.startDateValue,
        to_time: dateRange.endDateValue,
      }),
  );
  const dataOverAllArr = data ? data : [];
  const { logs = [], total = 0 } = dataReport || {};

  if (error || errorDetail) toast.error('error');

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const overAllGroupTable = React.useMemo(() => {
    if (!data) return overAllHeadGroupTable;
    return modifyArray(overAllHeadGroupTable, [
      { index: 1, name: `Platform (${data.platform_name})` },
    ]);
  }, [data]);

  const headGroupTableModify = React.useMemo(() => {
    if (!data) return headPlaformGroupTable;
    return modifyArray(headPlaformGroupTable, [
      { index: 2, name: `Platform (${data.platform_name})` },
    ]);
  }, [data]);

  console.log('overAll: ', data);
  console.log('getWinLossGroupUserByPlatform: ', dataReport, logs);

  return (
    <ApplicationLayout>
      <Breadcrumbs
        keepSearchParams
        breadcrumbNameAddOn={{
          [`${location.pathname}`]: `${data?.platform_name || ''} (Platform)`,
        }}
      />
      <SummaryDateRangeContent
        onChange={onChangeDateRange}
        defaultValue={dateRange}
        value={dateRange}
      />
      {!dataOverAllArr ? (
        <LoadingBox />
      ) : (
        <>
          <Box my={2}>
            <Typography variant="h6" gutterBottom component="div">
              {`${data?.platform_name}'s Overall`}
            </Typography>
            <TableContainer component={Paper}>
              <Table aria-label="win lost table" size="small">
                <Thead heads={overAllGroupTable} align="center" />
                <Thead heads={overAllTableHead} align="center" />
                <TableBody>
                  {dataOverAllArr.map((row, index) => (
                    <TableRow key={index}>
                      <RoyaltyFeeGroup data={row} />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      )}
      {!dataReport ? (
        <LoadingBox />
      ) : (
        <>
          <Typography variant="h6" gutterBottom component="div">
            Provider's Win/Lose
          </Typography>
          <TableContainer component={Paper}>
            <Table aria-label="win lost table">
              <Thead heads={headGroupTableModify} align="center" />
              <Thead heads={tableHead} align="center" />
              <TableBody>
                {dataReport.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center">
                      {/* <Link to={`transaction/${row.username}?${searchParam}`}> */}
                      {row.username}
                      {/* </Link> */}
                    </TableCell>
                    <RoyaltyFeeGroup data={row} />
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell align="center">รวม</TableCell>
                  <RoyaltyFeeGroup data={dataOverAllArr?.[0] || []} disabledBg />
                </TableRow>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                    colSpan={9}
                    count={total}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      inputProps: { 'aria-label': 'rows per page' },
                      native: true,
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </>
      )}
    </ApplicationLayout>
  );
};

export default PlatformGroupUser;
